export default __webpack_public_path__ + "static/media/404Error.0ed04e00.png";